import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      "text-align": "end"
    }
  }, [_vm.withAddbutton ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2",
    staticStyle: {
      "margin-bottom": "1rem"
    },
    attrs: {
      disabled: _vm.isCancelled,
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.open();
      }
    }
  }, [_vm._v(" + Add new shipment ")]) : _vm._e(), _c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      headers: _vm.shipmentsHeaders,
      items: _vm.shipments,
      "hide-default-footer": "",
      "disable-pagination": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.label",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", {
          class: item.tracked ? "bold" : ""
        }, [_vm._v(" " + _vm._s(item.label ? item.label : "-") + " ")])];
      }
    }, {
      key: "item.carrierName",
      fn: function fn(_ref2) {
        var _vm$carriers;
        var item = _ref2.item;
        return [_c("div", {
          class: item.tracked ? "bold" : ""
        }, [_vm._v(" " + _vm._s((_vm$carriers = _vm.carriers) === null || _vm$carriers === void 0 || (_vm$carriers = _vm$carriers.find(function (c) {
          return c.id === item.idCarrier;
        })) === null || _vm$carriers === void 0 ? void 0 : _vm$carriers.name) + " ")])];
      }
    }, {
      key: "item.tracking",
      fn: function fn(_ref3) {
        var _item$trackingNumber, _item$trackingNumber2;
        var item = _ref3.item;
        return [item.trackingLink ? _c("div", [_c("i", {
          staticClass: "fas fa-external-link-alt mr-1"
        }), _c("a", {
          class: item.tracked ? "bold" : "",
          attrs: {
            target: "_blank",
            href: item.trackingLink
          }
        }, [_vm._v(" " + _vm._s(item.trackingNumber ? "#" + ((_item$trackingNumber = item.trackingNumber) === null || _item$trackingNumber === void 0 ? void 0 : _item$trackingNumber.toUpperCase()) : "No tracking number") + " ")])]) : _c("div", {
          class: item.tracked ? "bold" : ""
        }, [_vm._v(" " + _vm._s(item.trackingNumber ? "#" + ((_item$trackingNumber2 = item.trackingNumber) === null || _item$trackingNumber2 === void 0 ? void 0 : _item$trackingNumber2.toUpperCase()) : "-") + " ")])];
      }
    }, {
      key: "item.tracked",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c("div", {
          class: item.tracked ? "bold" : ""
        }, [_vm._v(" " + _vm._s(item.tracked ? "Yes" : "-") + " ")])];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c(VIcon, {
          attrs: {
            title: "Edit shipment",
            size: "1rem"
          },
          on: {
            click: function click($event) {
              return _vm.open(item.id);
            }
          }
        }, [_vm._v("fas fa-pen")])];
      }
    }], null, true)
  }), _c(VDialog, {
    attrs: {
      persistent: "",
      width: "800"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancel.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    attrs: {
      disabled: _vm.shipmentIsLoading
    },
    on: {
      click: _vm.cancel
    }
  })], 1), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v(_vm._s(_vm.trackingForm.idShipment ? "Edit" : "Add") + " shipment")])]), _c("div", {
    staticClass: "content-centered large"
  }, [_c(VForm, {
    staticClass: "form-content",
    on: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    },
    model: {
      value: _vm.trackingForm.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.trackingForm, "valid", $$v);
      },
      expression: "trackingForm.valid"
    }
  }, [_c(VCheckbox, {
    staticStyle: {
      "margin-bottom": "-1rem !important",
      width: "fit-content"
    },
    attrs: {
      label: "Shipment Tracked at this moment"
    },
    model: {
      value: _vm.trackingForm.tracked,
      callback: function callback($$v) {
        _vm.$set(_vm.trackingForm, "tracked", $$v);
      },
      expression: "trackingForm.tracked"
    }
  }), _c(VCombobox, {
    key: "carrier-" + _vm.renderCarriers,
    attrs: {
      loading: !_vm.carriers.length,
      items: _vm.carriers,
      "item-text": "nameAndEmail",
      "item-value": "id",
      "hide-selected": "",
      label: "Select a carrier",
      "hide-details": "auto",
      rules: [_vm.rules.mustNotBeEmpty]
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c("div", [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.nameAndEmail) + " ")]), _c(VSpacer), _c(VListItemAction, [_c("div", {
          staticClass: "list-item-actions"
        }, [_c(VBtn, {
          attrs: {
            icon: ""
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.openEditCarrierPopin(item);
            }
          }
        }, [_c(VIcon, [_vm._v("mdi-pencil")])], 1), _c(VBtn, {
          attrs: {
            icon: ""
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.confirmDeleteCarrier(item);
            }
          }
        }, [_c(VIcon, [_vm._v("mdi-delete")])], 1)], 1)])];
      }
    }, {
      key: "append-outer",
      fn: function fn() {
        return [_c(VIcon, {
          attrs: {
            small: ""
          },
          on: {
            click: function click($event) {
              return _vm.openNewCarrierPopin();
            }
          }
        }, [_vm._v("fa-plus")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.trackingForm.carrier,
      callback: function callback($$v) {
        _vm.$set(_vm.trackingForm, "carrier", $$v);
      },
      expression: "trackingForm.carrier"
    }
  }), _c(VTextField, {
    attrs: {
      placeholder: "Write tracking number",
      label: "Tracking number",
      "hide-details": "auto"
    },
    on: {
      input: function input($event) {
        _vm.trackingForm.inputTrackingNumber = _vm.trackingForm.inputTrackingNumber.trim();
      }
    },
    model: {
      value: _vm.trackingForm.inputTrackingNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.trackingForm, "inputTrackingNumber", $$v);
      },
      expression: "trackingForm.inputTrackingNumber"
    }
  }), _c(VTextarea, {
    ref: "inputTrackingUrl",
    attrs: {
      rows: "3",
      label: "Tracking link",
      placeholder: "Write tracking link",
      "hide-details": "auto",
      rules: [_vm.rules.mustBeHttpLinkOrEmpty]
    },
    on: {
      input: function input($event) {
        _vm.trackingForm.inputTrackingLink = _vm.trackingForm.inputTrackingLink.trim();
      }
    },
    model: {
      value: _vm.trackingForm.inputTrackingLink,
      callback: function callback($$v) {
        _vm.$set(_vm.trackingForm, "inputTrackingLink", $$v);
      },
      expression: "trackingForm.inputTrackingLink"
    }
  }), _c(VTextField, {
    attrs: {
      placeholder: "Write tracking label",
      label: "Label (optional)",
      "hide-details": "auto"
    },
    on: {
      input: function input($event) {
        _vm.trackingForm.label = _vm.trackingForm.label.trim();
      }
    },
    model: {
      value: _vm.trackingForm.label,
      callback: function callback($$v) {
        _vm.$set(_vm.trackingForm, "label", $$v);
      },
      expression: "trackingForm.label"
    }
  }), _c("div", {
    staticClass: "flex justify-end"
  }, [_vm.trackingForm.idShipment ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      text: "",
      loading: _vm.shipmentIsLoading
    },
    on: {
      click: function click($event) {
        return _vm.deleteShipment();
      }
    }
  }, [_vm._v(" Delete ")]) : _vm._e(), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      text: "",
      disabled: !_vm.trackingForm.valid,
      loading: _vm.shipmentIsLoading
    },
    on: {
      click: function click($event) {
        return _vm.manageSubmit();
      }
    }
  }, [_vm._v(" Save ")])], 1)], 1)], 1)], 1)], 1), _c("CarrierFormModal", {
    ref: "carrierFormModal",
    attrs: {
      id: _vm.editingCarrier.id
    },
    on: {
      entityAdded: _vm.handleCarriersUpdated,
      entityUpdated: _vm.handleCarriersUpdated
    }
  }), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };